import { render, staticRenderFns } from "./ExpensesTable.vue?vue&type=template&id=9f01f9a8"
import script from "./ExpensesTable.vue?vue&type=script&lang=js"
export * from "./ExpensesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports